module.exports = __webpack_public_path__ + "static/media/item_5_7_comp.fa2e4569.png";